/**
 * Guest Payment component
 * react-card-number
 * react-expiry-date'
 * react-card-security-code
 */
import React from 'react';
import PropTypes from 'prop-types'
import * as FPT from '../utility/fpt'
import CardNumber from 'react-card-number';
import ExpiryCreditCard from 'react-expiry-date'
import CardSecurityCode from 'react-card-security-code'
import CardType from '../components/card-type';
import IssueNumber from '../components/issue-number';
import StartDate from '../components/start-date';
import DateOfBirth from '../components/date-of-birth';

import { cardSpecsPropType, cardSpecPropType } from 'prop-validators';
import { defaultCardSpec, getSpecificCardSpec } from '../utility/card-utils';

const STYLES = {};

class PaymentComponent extends React.Component {
	constructor() {
		super();
		this.state = {
			cardSpec: defaultCardSpec,
			cardType: '',
			cardnumber: '',
			expiration: '',
			csc: '',

			errorMessageCardNumber: '',
			errorMessageExp: '',
			errMessageCSC: '',
		};
	}

	componentDidMount() {
		this.props.onRef(this)
	}

	componentWillUnmount() {
		this.props.onRef(undefined)
	}

	/*
	* Handle card type change
	*/
	handleChangeCardType (spec, cardType) {
		this.setState({cardSpec: spec, type: spec.type, errorMessageCardType: ''})
		this.handlePaymentInfo('type', spec.type);
	}

	/*
	* Handle card number change
	*/
	handleChangeCardNumber(cardnumber, cardSpec) {

		let cardType = cardSpec.type === 'card' ? this.state.type : cardSpec.type

		this.setState({ number: cardnumber, cardSpec: cardSpec, type: cardType });
		this.handlePaymentInfo('number', cardnumber);
	}

	/*
	* Handle expiration date change
	*/
	handleChangeDate(expiration) {
		this.setState({ expiration: expiration });
		this.handlePaymentInfo('expiration', expiration);
	}

	/*
	* Handle security code change
	*/
	handleChangeSecurityCode(securityCode) {
		this.setState({ securityCode: securityCode });
		this.handlePaymentInfo('securityCode', securityCode);
	}

	/*
	* Handle issue number change
	*/
	handleChangeIssueNumber(issueNumber) {
		this.setState({ issueNumber: issueNumber });
		this.handlePaymentInfo('issueNumber', issueNumber);
	}

	/*
	* Handle start date change
	*/
	handleChangeStartDate(startDate) {
		this.setState({ startDate: startDate });
		this.handlePaymentInfo('startDate', startDate);
	}

	/*
	* Handle date of birth change
	*/
	handleDateOfBirth(dateOfBirth) {
		this.setState({ dateOfBirth: dateOfBirth });
		this.handlePaymentInfo('dateOfBirth', dateOfBirth);
	}

	/*
	* Handle payment information
	*/
	handlePaymentInfo(name, value) {

		if (!name || !value) {
			return
		}
		const { cardSpecs: { autodetect = false } } = this.props
		let { cardSpec = {}, finalPropOut = {} } = this.state;
		let { ccNumber, csc, expirationDate, startDate, issueNumber, dob } = cardSpec.fields || {};

		if (!autodetect ) {
			finalPropOut.type = this.state.type;
		}

		if (ccNumber) {
			finalPropOut.number = this.state.number;
		}

		if (csc) {
			finalPropOut.securityCode = this.state.securityCode;
		}

		if (expirationDate) {
			finalPropOut.expiration = this.state.expiration;
		}

		if (startDate) {
			finalPropOut.startDate = this.state.startDate;
		}

		if (issueNumber) {
			finalPropOut.issueNumber = this.state.issueNumber;
		}

		if (dob) {
			finalPropOut.dateOfBirth = this.state.dateOfBirth;
		}

		// overriding with new value
		finalPropOut[name] = value;

		this.props.changePaymentInfo(finalPropOut)
	}

	/*
	* Validate input
	*/
	validateInputValue(value, fieldName, fieldInvalid) {

		let { errorMessages } = this.props;
		let { cardSpec : { fields: { ccNumber = {}, expirationDate = {}, csc = {} } } } = this.state;

		if (fieldName === 'errorMessageCardNumber') {
			let rexCard = new RegExp(`^(${ccNumber.pattern})$`);

			if (!rexCard.test(value)) {
				return errorMessages[fieldInvalid]
			}
		}

		if (fieldName === 'errorMessageExp') {
			let rexExp = new RegExp(`^(${expirationDate.pattern})$`)
			if (!rexExp.test(value)) {
				return errorMessages[fieldInvalid]
			}
		}

		if (fieldName === 'errorMessageCSC') {
			let cscLen = value && value.length
			let cscMax = csc.maxlength
			let cscMin = csc.minlength || cscMax

			if (!(cscLen >= cscMin && cscLen <= cscMax)) {
				return errorMessages[fieldInvalid]
			}
		}

		return ''
	}

	/*
	* Handle error message for selected field
	*/
	handleFieldBlur(value, fieldName, fieldRequired, fieldInvalid) {

		let { errorMessages, newErrorState = {} } = this.props;

		if (value) {
			newErrorState = { [fieldName]: this.validateInputValue(value, fieldName, fieldInvalid) }
		} else {
			newErrorState = { [fieldName]: errorMessages[fieldRequired] }
		}

		this.setState(newErrorState)
	}

	/*
	* Hide error message for selected field on blur
	*/
	handleFieldFocus(fieldName) {
		this.setState({ [fieldName]: '' })
	}

	/*
	* Handling required payment form fields
	*/
	handleRequiredFields (params){

		const { errorMessages, cardSpecs: { autodetect = false } } = this.props
		const { cardSpec = {}, finalPropOut = {} } = this.state
		const { ccNumber, csc, expirationDate, startDate, issueNumber, dob } = cardSpec.fields || {};

		let isValid = true
		let errorMessageCardType, errorMessageCardNumber, errorMessageExpiry, errorMessageCSC, errorMessageIssueNumber, errorMessageStartDate, errorMessageDateOfBirth
		let keysToValidate = Object.keys(params)

		keysToValidate.forEach((key) => {
			let value = params[key]

			switch (key) {
				case 'type':
					if (!value && !autodetect) {
						isValid = false;
						errorMessageCardType = errorMessages.REQUIRED_CARD_TYPE;
						FPT.trackError({ message: errorMessageCardType, fieldId: 'cardType',  code: 'REQUIRED_CARD_TYPE'});
					}
					break;
				case 'number':
					if (!value && ccNumber) {
						isValid = false;
						errorMessageCardNumber = errorMessages.REQUIRED_CARD_NUMBER;
						FPT.trackError({ message: errorMessageCardNumber, fieldId: 'cardnumber',  code: 'REQUIRED_CARD_NUMBER'});
					}
					break;
				case 'expiration':
					if (!value && expirationDate) {
						isValid = false;
						errorMessageExpiry = errorMessages.REQUIRED_EXPIRY;
						FPT.trackError({ message: errorMessageExpiry, fieldId: 'expiration',  code: 'REQUIRED_EXPIRY'});
					}
					break;
				case 'securityCode':
					if (!value && csc) {
						isValid = false;
						errorMessageCSC = errorMessages.REQUIRED_SECURITY_CODE;
						FPT.trackError({ message: errorMessageCSC, fieldId: 'csc',  code: 'REQUIRED_SECURITY_CODE'});
					}
					break;
				case 'dateOfBirth':
					if (!value && dob) {
						isValid = false;
						errorMessageDateOfBirth = errorMessages.REQUIRED_DATE_OF_BIRTH;
						FPT.trackError({ message: errorMessageDateOfBirth, fieldId: 'dateOfBirth',  code: 'REQUIRED_DATE_OF_BIRTH'});
					}
					break;
				case 'startDate':
					if (!value && startDate) {
						isValid = false;
						errorMessageStartDate = errorMessages.REQUIRED_START_DATE;
						FPT.trackError({ message: errorMessageStartDate, fieldId: 'startDate',  code: 'REQUIRED_START_DATE'});
					}
					break;
				case 'issueNumber':
					if (!value && issueNumber) {
						isValid = false;
						errorMessageIssueNumber = errorMessages.REQUIRED_ISSUER_NUMBER;
						FPT.trackError({ message: errorMessageIssueNumber, fieldId: 'email',  code: 'REQUIRED_ISSUER_NUMBER'});
					}
					break;
				default:
					break;
			}
		});

		if (!isValid) {
			this.setState({
				errorMessageCardType: errorMessageCardType,
				errorMessageCardNumber: errorMessageCardNumber,
				errorMessageExpiry: errorMessageExpiry,
				errorMessageCSC: errorMessageCSC,
				errorMessageDateOfBirth: errorMessageDateOfBirth,
				errorMessageStartDate: errorMessageStartDate,
				errorMessageIssueNumber: errorMessageIssueNumber,
			})
		}
		return isValid
	}


	handleCardNumberError(key) {
		const { errorMessages } = this.props;
		let errorMessageCardNumber = errorMessages[key];
		this.setState({ errorMessageCardNumber: errorMessageCardNumber });
		FPT.trackError({ message: errorMessageCardNumber, fieldId: 'cardNumber',  code: key});
	}

	/*
	* Handle security code error
	*/
	handleSecurityCodeError(key) {
		const { errorMessages } = this.props;
		this.setState({ errorMessageCSC: errorMessages[key] });
	}

	/*
	* Handle expiration code error
	*/
	handleExpirationError(key) {
		const { errorMessages } = this.props;
		this.setState({ errorMessageExpiry: errorMessages[key] });
	}

	render() {
		const { guestMessages: { help: { expiration: expirationHelp }, label: guestLabel, placeholder: guestPlaceholder }, cardSpecs: { autodetect = false } } = this.props
		const { cardType: cardTypePlaceholder, startDate: startDatePlaceholder, dateOfBirth: dateOfBirthPlaceholder, issueNumber: issueNumberPlaceholder} = guestPlaceholder || {}
		const {cardType: cardTypeLabel, cardnumber: cardnumberLabel, csc: cscLabel, cscplaceholder, expiration: expirationLabel, issueNumber: issueNumberLabel , startDate: startDateLabel, startDateMonthLabel, startDateYearLabel, dateOfBirth: dateOfBirthLabel} = guestLabel ||{}

		let { cardSpec: { fields: { ccNumber, csc, dob, expirationDate, issueNumber, startDate } } } = this.state;

		return(
			<div>
				<div className="row">
					{!autodetect &&
						<div className="col-md-12 col-sm-12 col-xs-12">
							<CardType {...this.props}
								label={cardTypeLabel}
								placeholder={cardTypePlaceholder}
								errorMessage={this.state.errorMessageCardType}
								changeCardType={(value) => this.handleChangeCardType(value)}/>
						</div>}

					<div className="col-md-12 col-sm-12 col-xs-12 card_number">
						<CardNumber
							showIsRequiredError={true}
							label={cardnumberLabel}
							errorMessage={this.state.errorMessageCardNumber}
							handleChangeCardNumber={(value, spec) => this.handleChangeCardNumber(value, spec)}
							handleFocus={(value) => this.handleFieldFocus('errorMessageCardNumber')}
							handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageCardNumber', 'REQUIRED_CARD_NUMBER', 'INVALID_CARD_NUMBER')}
							selectedCardSpec={this.state.cardSpec}
							cardSpecs={this.props.cardSpecs}/>
					</div>
				</div>

				<div className="row has_combo">
					{expirationDate && <div className="col-md-6 col-sm-12 col-xs-12 csc_component">
						<ExpiryCreditCard
							required={true}
							label={expirationLabel}
							placeholder={expirationHelp}
							errorMessage={this.state.errorMessageExpiry}
							handleChangeDate={(value) => this.handleChangeDate(value)}
							handleFocus={(value) => this.handleFieldFocus('errorMessageExpiry')}
							handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageExpiry', 'REQUIRED_EXPIRY', 'INVALID_EXPIRY')}
							cardSpec={this.state.cardSpec} />
					</div>}

					{csc && <div  className="col-md-6 col-sm-12 col-xs-12 expiry_component">
						<CardSecurityCode
							showIsRequiredError={true}
							label={cscLabel}
							placeholder={cscplaceholder}
							errorMessage={this.state.errorMessageCSC}
							handleChangeSecurityCode={(value) => this.handleChangeSecurityCode(value)}
							handleFocus={(value) => this.handleFieldFocus('errorMessageCSC')}
							handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageCSC', 'REQUIRED_SECURITY_CODE', 'INVALID_SECURITY_CODE')}
							cardSpec={this.state.cardSpec}/>
					</div>}

					{startDate && <div  className="col-md-6 col-sm-12 col-xs-12">
						<StartDate
							required={true}
							labelMonth={startDateMonthLabel}
							labelYear={startDateYearLabel}
							placeholder={startDatePlaceholder}
							errorMessage={this.state.errorMessageStartDate}
							handleChange={(value) => this.handleChangeStartDate(value)}
							handleFocus={(value) => this.handleFieldFocus('errorMessageStartDate')}
							handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageStartDate', 'REQUIRED_START_DATE', 'INVALID_START_DATE')}
							cardSpec={this.state.cardSpec}/>
					</div>}

					{issueNumber && <div  className="col-md-6 col-sm-12 col-xs-12">
						<IssueNumber
							required={true}
							label={issueNumberLabel}
							placeholder={issueNumberPlaceholder}
							errorMessage={this.state.errorMessageIssueNumber}
							handleChange={(value) => this.handleChangeIssueNumber(value)}
							handleFocus={(value) => this.handleFieldFocus('errorMessageIssueNumber')}
							handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageIssueNumber', 'REQUIRED_ISSUER_NUMBER', 'INVALID_ISSUER_NUMBER')}
							cardSpec={this.state.cardSpec}/>
					</div>}
				</div>
				{dob && <div className="row">
					<div className="col-md-12 col-sm-12 col-xs-12">
						<DateOfBirth
							required={true}
							label={dateOfBirthLabel}
							country={this.props.country}
							placeholder={dateOfBirthPlaceholder}
							errorMessage={this.state.errorMessageDateOfBirth}
							handleChange={(value) => this.handleDateOfBirth(value)}
							handleFocus={(value) => this.handleFieldFocus('errorMessageDateOfBirth')}
							handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageDateOfBirth', 'REQUIRED_DATE_OF_BIRTH', 'INVALID_DATE_OF_BIRTH')}
							cardSpec={this.state.cardSpec}/>
					</div>
				</div>}
			</div>
		)
	}
};

PaymentComponent.propTypes = {
	changePaymentInfo: PropTypes.func.isRequired,
};

export default PaymentComponent;



// WEBPACK FOOTER //
// ./containers/payment-component.js